import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FLEET_PLANNING_URL

export const getListDownloadAttachment = async (fleetTaskId) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/download-attachment/fleet-task/${fleetTaskId}`,
  })

  return response?.data
}

export const requestDownloadAttachment = async (fleetTaskId, activityType) => {
  const response = await apiClientV2({
    method: 'POST',
    baseURL,
    url: `/download-attachment/fleet-task/${fleetTaskId}/request`,
    data: {
      activity_type: activityType,
    },
  })

  return response?.data
}


